module.exports = __webpack_public_path__ + "img/philco.24234e37.png";